<mat-toolbar color="primary">
  <mat-toolbar-row class="container">
    <span>{{ (isEdit ? 'components.clinical-onboarding.document-templates.edit-title' : 'components.clinical-onboarding.document-templates.new-title') | translate }}</span>
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="!loading ? closeDialogue() : ''"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="container my-4">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'components.clinical-onboarding.document-templates.field-title' | translate }}</mat-label>
      <input matInput formControlName="title" maxlength="255">
    </mat-form-field>

    <p class="field-group-label">{{ 'components.clinical-onboarding.document-templates.field-scope' | translate }}</p>
    @if (isEdit) {
      <!-- Feedback utente: l'ambito non e' modificabile dopo la creazione, quindi
           niente radio (disabilitate) da mostrare - solo la scelta gia' fatta. -->
      <p class="scope-readonly-value">
        <mat-icon class="mr-1">{{ isGeneric ? 'public' : 'person' }}</mat-icon>
        {{ (isGeneric
          ? 'components.clinical-onboarding.document-templates.scope-generic'
          : 'components.clinical-onboarding.document-templates.scope-per-candidate') | translate }}
      </p>
      <p class="hint-text mt-1">{{ 'components.clinical-onboarding.document-templates.scope-locked-hint' | translate }}</p>
    } @else {
      <mat-radio-group formControlName="scope" class="d-flex flex-column">
        <mat-radio-button [value]="ClinicianDocumentTemplateScope.GENERIC" class="mb-2">
          {{ 'components.clinical-onboarding.document-templates.scope-generic' | translate }}
          <span class="option-hint">{{ 'components.clinical-onboarding.document-templates.scope-generic-hint' | translate }}</span>
        </mat-radio-button>
        <mat-radio-button [value]="ClinicianDocumentTemplateScope.PER_CANDIDATE">
          {{ 'components.clinical-onboarding.document-templates.scope-per-candidate' | translate }}
          <span class="option-hint">{{ 'components.clinical-onboarding.document-templates.scope-per-candidate-hint' | translate }}</span>
        </mat-radio-button>
      </mat-radio-group>
    }

    <p class="field-group-label mt-4">{{ 'components.clinical-onboarding.document-templates.field-requires-upload' | translate }}</p>
    <mat-radio-group formControlName="requires_upload" class="d-flex flex-column">
      <mat-radio-button [value]="false" class="mb-2">
        {{ 'components.clinical-onboarding.document-templates.requires-upload-false' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="true">
        {{ 'components.clinical-onboarding.document-templates.requires-upload-true' | translate }}
      </mat-radio-button>
    </mat-radio-group>

    @if (isGeneric) {
      <div class="mt-4">
        <input type="file" accept=".pdf" #fileInput hidden (change)="onFileSelected($event)">
        <button mat-stroked-button type="button" color="primary" (click)="fileInput.click()">
          <mat-icon class="mr-1">upload</mat-icon>
          {{ (file ? file.name : (isEdit ? 'components.clinical-onboarding.document-templates.replace-file' : 'components.clinical-onboarding.document-templates.choose-file')) | translate }}
        </button>
        @if (isEdit && !file) {
          <p class="hint-text mt-1">{{ 'components.clinical-onboarding.document-templates.keep-current-file-hint' | translate }}</p>
        }
      </div>
    }

    <mat-expansion-panel class="mt-4 advanced-settings-panel">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="mr-2">tune</mat-icon>
          {{ 'components.clinical-onboarding.document-templates.advanced-settings' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-checkbox formControlName="visible_only_if_employer_public" class="d-block mb-2">
        {{ 'components.clinical-onboarding.document-templates.visible-only-if-employer-public' | translate }}
      </mat-checkbox>
      <mat-checkbox formControlName="counts_as_invoice" [disabled]="!countsAsInvoiceAvailable" class="d-block">
        {{ 'components.clinical-onboarding.document-templates.counts-as-invoice' | translate }}
      </mat-checkbox>
      @if (!countsAsInvoiceAvailable) {
        <p class="hint-text mb-0">{{ 'components.clinical-onboarding.document-templates.counts-as-invoice-hint' | translate }}</p>
      }
    </mat-expansion-panel>
  </div>

  <div class="buttons-container container mb-3 d-flex justify-content-center">
    <button mat-stroked-button class="text-dark-purple border-purple mr-2" type="button" [disabled]="loading" (click)="closeDialogue()">{{ 'generic.buttons.cancel-and-back' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="loading">{{ 'generic.buttons.save' | translate }}</button>
  </div>
</form>
